import { schema } from 'normalizr';

export const functionSchema = new schema.Entity('functions', {}, { idAttribute: 'FunctionId' });

export const functionListSchema = [functionSchema];
